import CloseIcon from "@mui/icons-material/Close";
import { DialogContent, DialogContentText, Box, IconButton, Popper, Fade, DialogTitle, capitalize } from "@mui/material";
import { ReactElement, useContext } from "react";
import { useTranslation } from "react-i18next";

import { COLORS } from "ui/variables";

import { ReservationsContext } from "./Reservations";

export interface MemoProps {
    onClose?: () => void
}

export function DailyMessage({ onClose }: MemoProps): ReactElement {
    const { t } = useTranslation();

    const { reservationsControl: { closeDailyMessage, dailyMessage, isDailyMessageClosed } } = useContext(ReservationsContext);

    return (
        <Popper
            transition
            anchorEl={undefined}
            open={dailyMessage?.isPublished && dailyMessage?.context && !isDailyMessageClosed ? true : false}
            sx={{
                alignItems: "center",
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                left: 0,
                position: "absolute",
                right: 0,
                top: 0,
                zIndex: 10,
            }}
        >
            {({ TransitionProps }) =>
                <Fade {...TransitionProps} timeout={350}>
                    <Box sx={{
                        alignItems: "center",
                        bgcolor: COLORS.main,
                        borderColor: COLORS.black,
                        borderStyle: "dotted",
                        borderWidth: "4px",
                        display: "flex",
                        minHeight: "350px",
                        minWidth: "700px",
                        pointerEvents: "all",
                        position: "absolute",
                        zIndex: 20,
                    }}>
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                            }}
                            onClick={closeDailyMessage}
                        >
                            <CloseIcon sx={{ color: COLORS.black }} />
                        </IconButton>
                        <Box sx={{
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                        }}>
                            <DialogContent sx={{ flexGrow: 1, pb: "3.5em" }}>
                                <DialogTitle sx={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}>
                                    { capitalize(t("modules.reservations.dailyMessage.title")) }
                                </DialogTitle>
                                <DialogContentText sx={{
                                    color: COLORS.black,
                                    fontSize: 19.2,
                                    lineHeight: 1.7,
                                    pointerEvents: "none",
                                    textAlign: "center",
                                    whiteSpace: "pre-wrap",
                                }}>
                                    { dailyMessage?.context }
                                </DialogContentText>
                            </DialogContent>
                        </Box>
                    </Box>
                </Fade>
            }
        </Popper>
    );
}